// Copyright 2018 Sorama B.V.

import {
    GenericMeasurement,
    HolographyProjection,
    HolographyProjectionAnalysisProperties,
    HolographyProjectionHologramAnalysisProperties,
    SpatialEnergyCurveSetAnalysisProperties,
    SpatialEnergyCurveSetCurve,
    SpatialEnergyCurveSetHologramAnalysisProperties,
} from "datatypes/SoramaWebApi";

export abstract class IHolographyHologramProcessingService {
    /**
     * Get holography projections for the given measurement using the provided holograms
     * @param measurement Measurement to get the measurement data for the holography projections from.
     * @param properties Properties for each of the projections to compute.
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates.
     */
    abstract getHolographyProjections(
        measurement: GenericMeasurement,
        properties: HolographyProjectionHologramAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<HolographyProjection[]>;

    /**
     * Get spatial energy distribution for the given measurement and properties.
     * @param measurement Measurement to get the data from.
     * @param properties Properties for the compute call including the hologram data.
     * @param computationProgressCallback Callback for the compute progress.
     */
    abstract getSpatialEnergyCurve(
        measurement: GenericMeasurement,
        properties: SpatialEnergyCurveSetHologramAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<SpatialEnergyCurveSetCurve>;
}

export abstract class IHolographyProcessingService {
    /**
     * Get holography projections for the given measurement.
     * @param measurement Measurement to get the measurement data for the holography projections from.
     * @param properties Properties for each of the projections to compute.
     * @param computationProgressCallback Optional progress callback which will receive periodic progress updates.
     */
    abstract getHolographyProjections(
        measurement: GenericMeasurement,
        properties: HolographyProjectionAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<HolographyProjection[]>;

    /**
     * Get spatial energy distribution for the given measurement and properties.
     * @param measurement Measurement to get the data from.
     * @param properties Properties for the compute call.
     * @param computationProgressCallback Callback for the compute progress.
     */
    abstract getSpatialEnergyCurve(
        measurement: GenericMeasurement,
        properties: SpatialEnergyCurveSetAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<SpatialEnergyCurveSetCurve>;
}
